import { gql } from '@apollo/client';

export const fetchInvoiceGroupsBySoldToAddressIds = gql`
  query fetchInvoiceGroupsBySoldToAddressIds($ids: [ID!]!) {
    invoiceGroupsForShipToPartyIds(ids: $ids) {
      shipToPartiesBillingGroupIds
    }
  }
`;
